export default __webpack_public_path__ + "static/media/PCQ.5e499293.png";